import { render, staticRenderFns } from "./Pass_control.vue?vue&type=template&id=ab6de82a"
import script from "./Pass_control.vue?vue&type=script&lang=js"
export * from "./Pass_control.vue?vue&type=script&lang=js"
import style0 from "./Pass_control.vue?vue&type=style&index=0&id=ab6de82a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports